module.exports = __webpack_public_path__ + "static/img/4.6832ccd1.svg";